import cn from 'clsx'
import {Button as AntdButton, ButtonProps as AntdButtonProps, Space} from 'antd'

import './Button.scss'
import {DropdownIcon} from 'common/components'

interface ButtonProps extends AntdButtonProps {
  variant?: 'primary' | 'text' | 'secondary' | 'danger' | 'grey' | 'grey2' | 'v2'
  primary?: boolean
  dropdown?: boolean
  open?: boolean
}

export default function Button({
  children,
  className,
  variant = 'primary',
  dropdown,
  open,
  ...props
}: ButtonProps) {
  const isRound = ['secondary', 'danger', 'grey'].includes(variant)

  const contentEl = dropdown ? (
    <Space size={6}>
      <span>{children}</span>
      <DropdownIcon />
    </Space>
  ) : (
    children
  )

  return (
    <AntdButton
      className={cn(
        className,
        `Button Button_type_${variant}`,
        open && 'Button_open',
        (variant === 'v2') && 'Button_type_v2'
      )}
      type={variant === 'text' ? 'text' : 'primary'}
      size={isRound ? 'small' : undefined}
      shape={isRound ? 'round' : undefined}
      {...props}
    >
      {contentEl}
    </AntdButton>
  )
}
